module.exports = __webpack_public_path__ + "media/images/content/icon_car-4e19624d7b87650c65ec0dc41cdb60d5.svg";